var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-container"},[_c('proveedores-selector'),_c('laboratorios-selector'),_c('tipo-articulo-selector'),_c('categorias-selector'),_c('subfamilias-selector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }